import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as u, unref as a, renderSlot as V, createElementVNode as e, createCommentVNode as H } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, A = { key: 2 }, f = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconVectorTwo"
}, Z = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = L(s);
    return (p, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      V(p.$slots, "default"),
      a(n) === "bold" ? (t(), o("g", g, l[0] || (l[0] = [
        e("path", { d: "M232.49,200.49l-32,32a12,12,0,0,1-17-17L195,204H80a12,12,0,0,1-12-12V69L56.49,80.49a12,12,0,1,1-17-17l32-32a12,12,0,0,1,17,0l32,32a12,12,0,0,1-17,17L92,69V180H195l-11.52-11.51a12,12,0,0,1,17-17l32,32A12,12,0,0,1,232.49,200.49Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (t(), o("g", m, l[1] || (l[1] = [
        e("path", {
          d: "M224,56V192H80V40H208A16,16,0,0,1,224,56Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M229.66,197.66l-32,32a8,8,0,0,1-11.32-11.32L204.69,200H80a8,8,0,0,1-8-8V59.31L53.66,77.66A8,8,0,0,1,42.34,66.34l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L88,59.31V184H204.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,229.66,197.66Z" }, null, -1)
      ]))) : a(n) === "fill" ? (t(), o("g", A, l[2] || (l[2] = [
        e("path", { d: "M229.66,197.66l-32,32A8,8,0,0,1,184,224V200H80a8,8,0,0,1-8-8V80H48a8,8,0,0,1-5.66-13.66l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,112,80H88V184h96V160a8,8,0,0,1,13.66-5.66l32,32A8,8,0,0,1,229.66,197.66Z" }, null, -1)
      ]))) : a(n) === "light" ? (t(), o("g", f, l[3] || (l[3] = [
        e("path", { d: "M228.24,196.24l-32,32a6,6,0,0,1-8.48-8.48L209.51,198H80a6,6,0,0,1-6-6V54.49L52.24,76.24a6,6,0,0,1-8.48-8.48l32-32a6,6,0,0,1,8.48,0l32,32a6,6,0,1,1-8.48,8.48L86,54.49V186H209.51l-21.75-21.76a6,6,0,0,1,8.48-8.48l32,32A6,6,0,0,1,228.24,196.24Z" }, null, -1)
      ]))) : a(n) === "regular" ? (t(), o("g", h, l[4] || (l[4] = [
        e("path", { d: "M229.66,197.66l-32,32a8,8,0,0,1-11.32-11.32L204.69,200H80a8,8,0,0,1-8-8V59.31L53.66,77.66A8,8,0,0,1,42.34,66.34l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L88,59.31V184H204.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,229.66,197.66Z" }, null, -1)
      ]))) : a(n) === "thin" ? (t(), o("g", k, l[5] || (l[5] = [
        e("path", { d: "M226.83,194.83l-32,32a4,4,0,0,1-5.66-5.66L214.34,196H80a4,4,0,0,1-4-4V49.66L50.83,74.83a4,4,0,0,1-5.66-5.66l32-32a4,4,0,0,1,5.66,0l32,32a4,4,0,0,1-5.66,5.66L84,49.66V188H214.34l-25.17-25.17a4,4,0,0,1,5.66-5.66l32,32A4,4,0,0,1,226.83,194.83Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  Z as default
};
